import { RuleObject } from "antd/es/form";

export const validatePassportDivisionCode = (
  rule: RuleObject,
  value: string
) => {
  if (value) {
    const field = value.replace(/[^0-9]/g, "");

    if (!/^\d{6}$/.test(field)) {
      return Promise.reject("Код подразделения должен содержать 6 символов");
    }
  }

  return Promise.resolve();
};

export const validatePassportSeries = (rule: RuleObject, value: string) => {
  if (value) {
    const field = value.replace(/[^0-9]/g, "");

    if (!/^\d{4}$/.test(field)) {
      return Promise.reject("Серия паспорта должна содержать 4 символа");
    }
  }

  return Promise.resolve();
};

export const validatePassportNumber = (rule: RuleObject, value: string) => {
  if (value) {
    const field = value.replace(/[^0-9]/g, "");

    if (!/^\d{6}$/.test(field)) {
      return Promise.reject("Номер паспорта должен содержать 6 символов");
    }
  }

  return Promise.resolve();
};

export const validatePassportAddressIndex = (
  rule: RuleObject,
  value: string
) => {
  if (value) {
    const field = value.replace(/[^0-9]/g, "");

    if (!/^\d{5,6}$/.test(field)) {
      return Promise.reject("Индекс должен содержать 5 или 6 символов");
    }
  }

  return Promise.resolve();
};

export const validateBik = (rule: RuleObject, value: string) => {
  const field = value?.replace(/[^0-9]/g, "");

  if (!/^\d{9}$/.test(field)) {
    return Promise.reject("БИК должен содержать 9 символов");
  }

  return Promise.resolve();
};

export const validateObjectMember =  <T>(obj: T, exceptions: string[] = []) => {
  for (const key in obj) {
    if (exceptions && exceptions.find((element) => element === key)) continue;
    if (!obj[key]) return false;
  }
  return true;
};
